import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/** Render children into document.body so position:fixed escapes any
 * transformed/blurred ancestor (e.g. <main class="animate-rise">) that would
 * otherwise become the containing block and mis-position the overlay. */
export function Portal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
